/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Method_OtherInputs */

const en_my_payments_method_other = /** @type {(inputs: My_Payments_Method_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other`)
};

const pl_my_payments_method_other = /** @type {(inputs: My_Payments_Method_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inna`)
};

/**
* | output |
* | --- |
* | "other" |
*
* @param {My_Payments_Method_OtherInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_method_other = /** @type {((inputs?: My_Payments_Method_OtherInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Method_OtherInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_method_other(inputs)
	return en_my_payments_method_other(inputs)
});